export default "__VITE_ASSET__DdU6JPld__"